import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';

const Tc = () => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const { locale } = useRouter();

    const spLinks: Record<string, string> = {
        us: 'https://us.ecoflow.com/pages/shipping-policy',
        ca: 'https://ca.ecoflow.com/pages/order-processing-shipping-policy',
    };

    const checkUrl = (url: string) => {
        url = Array.isArray(url) ? url[0] : url;

        if (!url.startsWith('https')) {
            return `https://${url}`;
        } else {
            return url;
        }
    };

    return (
        <div className={`${styles.tc} GtmModuleData-section`} data-section-id={styles.tc} data-section-title={'Terms & Conditions'}>
            <div className="content">
                <p className="text">
                    {t.rich('tc_text', {
                        s: (text: string) => <span className="strong">{text}</span>,
                        a: (text: string) => (
                            <a className="link" href={`mailto:${text}`}>
                                {text}
                            </a>
                        ),
                        link: (text: string) => (
                            <a className="link" target="_blank" href={`${checkUrl(text)}`} rel="noreferrer">
                                {text}
                            </a>
                        ),
                        sp: (text: string) => (
                            <a className="link" target="_blank" href={spLinks[locale] || spLinks.us} rel="noreferrer">
                                {text}
                            </a>
                        ),
                        rp: (text: string) => (
                            <a className="link" target="_blank" href={`https://${locale}.ecoflow.com/pages/ecoflow-return-policy`} rel="noreferrer">
                                {text}
                            </a>
                        ),
                        link1: (text: string) => (
                            <a className="link" target="_blank" href="https://homebattery.ecoflow.com/us/support/warrantly-and-policy" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            </div>
        </div>
    );
};

export default Tc;
